import React, { ImgHTMLAttributes, FC } from 'react';
import { css } from '@emotion/core';

export type CustomIconProps = ImgHTMLAttributes<HTMLImageElement> & {
  testId?: string;
  isMini?: boolean;
  isEnabled?: boolean;
};

const miniCanvasStyle = css`
  height: 16px;
  width: 16px;
`;

const defaultCanvasStyle = css`
  width: 22px;
  height: 22px;
`;

const imgStyle = css`
  height: 100%;
  width: 100%;
`;

const CustomIcon: FC<CustomIconProps> = ({ testId, src, className, isMini }) => (
  <div className={className} css={[isMini ? miniCanvasStyle : defaultCanvasStyle]}>
    <img src={src} data-testid={testId} css={imgStyle} alt="" />
  </div>
);

export default CustomIcon;
